import React from 'react';

import { Box, Grid2 as Grid } from '@mui/material';
import { PostTypes, PostVisibilities } from '../../Utils/Types';

import PostCard from '../DesignSystem/PostCard';
import ButtonViewAll from './ListOfCards/ButtonViewAll';
import usePostsQuery from '../../Hooks/usePostsQuery';
import { Space } from '../../Utils/Types/Space';
import { FilteringType } from '../../Utils/Types/UiSection';
import { PostType } from '../../Utils/Types/Posts';
import { postPath } from '../../Utils/routes';

interface FoldersLayerProps {
  space: Space;
  filteringType?: FilteringType;
  parentId?: number | null;
  postRecordIds?: number[];
  fetchAll?: boolean;
  types?: PostType[];
}

export default function FoldersLayer({
  space,
  filteringType = 'all',
  parentId,
  types,
  postRecordIds = [],
  fetchAll = false,
}: FoldersLayerProps) {
  let limit = 100;

  if (parentId && !fetchAll) {
    limit = 3;
  }

  const { posts, paging } = usePostsQuery(parentId ? 'subfolder' : 'folders', {
    space,
    limit: limit,
    parentId,
    types: types || parentId ? [] : [PostTypes.FOLDER],
    extraParams: {
      filter: {
        ...(filteringType === 'custom' ? { post_record_id: postRecordIds } : {}),
        ...(filteringType === 'all' ? { has_parent: true } : {}),
      },
    },
    sort: '-dates',
    visibilities: [PostVisibilities.PUBLISHED],
  });

  if (!posts.length) {
    return null;
  }

  return (
    <Box sx={{ wordBreak: 'break-word' }}>
      <Grid container spacing={2} sx={{ justifyContent: 'flex-start' }}>
        {posts.map((post: any) => (
          <Grid key={post.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <PostCard key={post.id} post={post} entity={space} direction="row" />
          </Grid>
        ))}

        {filteringType === 'children' && paging?.total_pages > 1 && parentId && (
          <Grid key="view-all" size={12} sx={{ textAlign: 'center', marginTop: '1rem' }}>
            <ButtonViewAll
              href={postPath(space.slug, parentId)}
              variant="text"
              sx={{ width: '100%' }}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
